/**
 * WALTZ_ARCHETYPE
 *
 * The "Ground Truth" statistical profile for Waltz (3/4 Time).
 * Traits:
 * - Strong "Oom-Pah-Pah" Pulse (Dynamic Emphasis on Beat 1)
 * - Moderate Harmonic Rhythm (1 bar per chord usually)
 * - Lyrical / Melodic focus
 */

import { ACTIVE_ARCHETYPE } from './BaseArchetype.js';

export const WALTZ_ARCHETYPE = {
    ...ACTIVE_ARCHETYPE,

    // Voice Distribution: Accompaniment focused.
    // Low (Bass on 1) and Mid (Chords on 2,3) are critical.
    voiceDistribution: {
        ...ACTIVE_ARCHETYPE.voiceDistribution,
        low: 0.30,
        mid: 0.40,
        high: 0.30, // Melody
        tolerance: 0.15
    },

    // Dynamic Range: Moderate with Pulse.
    // We expect regular accents (Beat 1), creating variance.
    dynamicRange: {
        ...ACTIVE_ARCHETYPE.dynamicRange,
        minVariance: 0.10,
        targetVariance: 0.25,
        dynamicShape: 'pulse' // New hint?
    }
};
